import {Component, TemplateRef} from '@angular/core';

import {ToastService} from './toast-service';


@Component({
    selector: 'app-toasts-msg',
    template: `
    @for (toast of toastService.toasts; track toast) {
      <ngb-toast
        [class]="toast.classname"
        [autohide]="true"
        [delay]="toast.delay"
        (hidden)="toastService.remove()">
        @if (isTemplate(toast)) {
          <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        } @else {
          {{ toast.textOrTpl }}
        }
      </ngb-toast>
    }
    `,
    host: { '[class.ngb-toasts]': 'true' },
    standalone: false
})
export class ToastsContainer {
  constructor(public toastService: ToastService) {}

  isTemplate(toast) { return toast.textOrTpl instanceof TemplateRef; }
}
